<template>
  <div style="margin-top:30px">
    <el-form ref="form" :rules="rules" :model="form" label-width="80px">
      <el-form-item label="班组名称" prop="name" style="margin-right:15px">
        <el-input v-model="form.name" placeholder="请输入班组名称" style="width:100%" />
      </el-form-item>
      <el-form-item label="力别" prop="forceTypeName" style="margin-right:15px">
        <el-select v-model="form.forceTypeName" placeholder="请选择力别  " clearable style="width:100%" @change="changeForceType($event)">
          <el-option
            v-for="item in forceTypeData"
            :key="item.code"
            :label="item.name"
            :value="item.code"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="所属部门" prop="departmentCode" style="margin-right:15px">
        <departmentSelect ref="departmentSelect" style="width:100%" @setDepartmentCode="setDepartmentCode" />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="funcCancel">取 消</el-button>
      <el-button type="primary" @click="funcSubmit">确 定</el-button>
    </div>
  </div>
</template>
<script>
import request from '@/utils/request'
import departmentSelect from './departmentSelect.vue'
export default {
  name: 'TeamAdd',
  components: {
    departmentSelect
  },
  data() {
    return {
      forceTypeData:[],

      form: {
        forceTypeCode:'',
        forceTypeName:'',
        code: '',
        name: '',
        partyGroupCode: '',
        departmentCode: ''
      },

      rules: {
        name: [
          { required: true, message: '请输入班组名称', trigger: 'blur' },  
        ],
        departmentCode: [
          { required: true, message: '请选择所属部门', trigger: 'blur' }
        ],
        forceTypeName: [
          { required: true, message: '请选择力别', trigger: 'blur' }
        ]

      },
      departmentList: []
    }
  },
  created() {
    this.findDepartmentList()
    this.findForceType()

  },
  methods: {
    // 获取力别数据
    findForceType() {
      request({
        url: '/ntocc-wms-api/forceType/listForceType',
        method: 'get',
      }).then(response => {
        this.forceTypeData = response.data
      })
    },
    // 选择力别
    changeForceType(e){
      this.form.forceTypeCode = e
      const str = this.forceTypeData.find(i => i.code === e)
      this.form.forceTypeName = str.name

    },
    // 选择客户
    setDepartmentCode(value) {
        this.form.partyGroupCode = value[0]
        this.form.departmentCode = value[1]
    },
    // 查询部门
    findDepartmentList() {
      request({ url: `/ntocc-basic-api/department`, method: 'get' }).then(response => {
        this.departmentList = response.data.records
      })
    },
    // 提交
    funcSubmit() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          const rLoading = this.openLoading();
          const data = this.form
          request({ url: '/ntocc-basic-api/team', method: 'post', params: data }).then(response => {
            rLoading.close();
            this.$message({ message: response.msg, type: 'success' })
            this.$emit('fatherAddMethod')
          }).then(() => {
              this.$refs['form'].resetFields()
              this.$refs.departmentSelect.setSelectValue('')
          })
        } else {
          return false
        }
      })
    },
    // 取消
    funcCancel() {
      this.$emit('fatherCancelMethod', 'add')
    }
  }
}
</script>
<style lang="scss" scoped>
    .dialog-footer {
        margin:15px 0 15px 0;
        width: 175px;
        float: right;
    }
</style>
